import { ISettings } from 'my-poppies-b2b-types';

export const dummyDataSettings: ISettings = {
  user: {
    role: 'EVA',
    name: 'Jasmin',
    language: 'de',
  },
  availableCustomerCountriesPerUserRole: {
    BERNHARD: ['AT'],
    SAM: ['AT'],
    EVA: ['AT', 'BE', 'DE', 'ES', 'FR', 'GR', 'IT', 'NL', 'PL', 'PT'],
  },
  preorderLimits: { standardLimitPerPosition: 100, expressLimitTotal: 50 },
  statusCategoryMapping: {
    NEW: 'INFO',
    DECLINED: 'WARN',
    BEING_PREPARED: 'INFO',
    SHIPPED: 'INFO',
    DELIVERED: 'SUCCESS',
    INTERNAL_ORDER_COMPLETED: 'SUCCESS',
    FLAWED: 'ERROR',
    PREORDER: 'INFO',
    PREORDER_COMPLETED: 'SUCCESS',
    LABEL_CREATED: 'INFO',
    IN_TRANSIT: 'INFO',
    DELAYED: 'WARN',
    OUT_FOR_DELIVERY: 'INFO',
    FAILED_ATTEMPT: 'WARN',
    UNABLE_TO_DELIVER: 'ERROR',
    RETURNED: 'INFO',
    CANCELLED: 'ERROR',
  },
  availableUserRolesForNewPositionsPerUserRole: { BERNHARD: ['EVA', 'SAM'], SAM: ['EVA', 'SAM'], EVA: ['EVA', 'SAM'] },
  visibleSectionsOnRootScreenPerUserRole: {
    BERNHARD: [
      'ADD_NEW_ORDER',
      'NEW_ORDERS',
      'DECLINED_ORDERS',
      'ORDER_OVERVIEW',
      'ADD_NEW_PREORDER',
      'PREORDER_OVERVIEW',
      'ADD_NEW_INTERNAL_ORDER',
      'ADD_NEW_PAYMENT',
      'PAYMENTS',
      'CONTACT_LIST',
      'ARCHIVE',
      'GUIDELINE',
      'POSITIONS',
      'OPTIONS',
      'ACCOUNT',
    ],
    SAM: ['NEW_ORDERS', 'ORDER_OVERVIEW'],
    EVA: [
      'ADD_NEW_ORDER',
      'NEW_ORDERS',
      'DECLINED_ORDERS',
      'ORDER_OVERVIEW',
      'ADD_NEW_PREORDER',
      'PREORDER_OVERVIEW',
      'ADD_NEW_INTERNAL_ORDER',
      'ADD_NEW_PAYMENT',
      'PAYMENTS',
      'CONTACT_LIST',
      'ARCHIVE',
      'GUIDELINE',
      'POSITIONS',
      'OPTIONS',
      'ACCOUNT',
    ],
  },
  visibleOrderStatusPerUserRole: {
    BERNHARD: ['ALL_ORDERS', 'ALL_OPEN_ORDERS', 'NEW', 'DECLINED', 'BEING_PREPARED', 'SHIPPED', 'DELIVERED', 'INTERNAL_ORDER_COMPLETED', 'FLAWED'],
    SAM: ['NEW', 'DECLINED', 'BEING_PREPARED'],
    EVA: ['ALL_ORDERS', 'ALL_OPEN_ORDERS', 'NEW', 'DECLINED', 'BEING_PREPARED', 'SHIPPED', 'DELIVERED', 'INTERNAL_ORDER_COMPLETED', 'FLAWED'],
  },
  visiblePreorderStatusPerUserRole: {
    BERNHARD: ['ALL_PREORDERS', 'ALL_OPEN_PREORDERS', 'PREORDER', 'PREORDER_COMPLETED'],
    SAM: [],
    EVA: ['ALL_PREORDERS', 'PREORDER', 'PREORDER_COMPLETED'],
  },
  isAllowedToEditOrders: {
    BERNHARD: true,
    SAM: false,
    EVA: true,
  },
  isAllowedToEditPreorders: {
    BERNHARD: true,
    SAM: false,
    EVA: false,
  },
  isAllowedToRedirectShippedOrders: {
    BERNHARD: true,
    SAM: false,
    EVA: false,
  },
  isAllowedToEditPaymentInterval: {
    BERNHARD: true,
    SAM: false,
    EVA: false,
  },
  isAllowedToEditBillingType: {
    BERNHARD: true,
    SAM: false,
    EVA: false,
  },
  isAllowedToApproveOrDeclineOrders: {
    BERNHARD: true,
    SAM: false,
    EVA: true,
  },
  isAllowedToCancelOrders: {
    BERNHARD: true,
    SAM: false,
    EVA: true,
  },
  visibleOptionsPerUserRole: {
    BERNHARD: ['PRICES'],
    SAM: ['PRICES'],
    EVA: ['PRICES'],
  },
  selectSenderShown: {
    BERNHARD: true,
    SAM: false,
    EVA: false,
  },
  availableSender: {
    MYP: 'My Poppies GmbH',
    SAM: 'Sam Kumar',
    'AT-Zufall': 'AT-Zufall',
    EVA: 'Franz Baumühlner, Landwirtschaftliche Urprodukte',
  },
};
